import { redirect } from 'next/navigation'
import { siteOrigin } from '../../../constants/routing'

export const encodeNextParam = (next: string) => {
  return next.startsWith(encodeURIComponent('/'))
    ? // assume already encoded
      next
    : encodeURIComponent(next)
}

export const decodeNextParam = (next: string) => {
  return next.startsWith('/')
    ? // assume already deencoded
      next
    : decodeURIComponent(next)
}

export const redirectToNextParam = (next: string, dryRun?: boolean) => {
  // prevent open redirect vulnerability by making sure origin is ours.
  const asUrl = new URL(decodeNextParam(next), siteOrigin)
  if (asUrl.origin === siteOrigin) {
    const redirectTo = asUrl.pathname + asUrl.search + asUrl.hash
    if (dryRun) return redirectTo
    redirect(redirectTo)
  }
}
